import { useQuery } from "@tanstack/react-query";
import axios from "axios";

type PatientInfo = {
  patient_first_name: string;
  patient_last_name: string;
  patient_street_address: string;
  patient_city_address: string;
  patient_state: string;
  patient_zip: string;
  patient_phone_number: string;
  registration_code: string;
}

const useQueryPatientInfo = (id: string | undefined) => {
  return useQuery({
    queryKey: ["patient-info", id],
    queryFn: async () => {
      const { data } = await axios.get<PatientInfo>(`patients/${id}`);
      console.log(data);
      return data;
    },
    retry: 0,
    enabled: !!localStorage.getItem('Authorization') && !!id,
  });
};

export default useQueryPatientInfo;
